/**
 * схема для настроек таблицы клиентов
 * @property {array} settingsItems - элементы настроек
 */
let schemeSettingsHistory = {
    columnSettings: {
        name: {
            type: 'text'
        },
        user_id: {
            type: 'text'
        },
        uploader_id: {
            type: 'text'
        },
        status:{
            type: 'text'
        },
        directory:{
            type: 'link'
        },
        created_at: {
            type: 'text'
        },
    },
    labels: {
        name: 'Название файла',
        user_id: 'Кому загружали',
        uploader_id: 'Кто загружал',
        status: 'Статус загрузки',
        directory: 'Ссылка на файл',
        created_at: 'Дата создания'
    },
    statuses: {
        1: "Чтение",
        2: "Валидация",
        3: "Импорт"
    }
}

export default schemeSettingsHistory;